import { UserOrg } from "types/auth";

import { EMAIL_LANGUAGE, emailLang } from "config/config-general";
import { getCountryData, TCountryCode } from "countries-list";

export function getNativeCountryName(countryCode?: string): string {
  if (!countryCode) return "-";

  return getCountryData(countryCode as TCountryCode)?.native || countryCode;
}

export function getEmailLanguageFromUserOrg(userOrg: UserOrg | null | undefined): EMAIL_LANGUAGE {
  let lang = "en";
  if (userOrg) {
    if (userOrg.defaultLanguageCode) {
      lang = userOrg.defaultLanguageCode;
    } else if (userOrg.countryCode) {
      const countryData = getCountryData(userOrg.countryCode as TCountryCode);
      if (countryData.languages && countryData.languages[0]) {
        lang = countryData.languages[0];
      }
    }
    if (!emailLang.includes(lang as EMAIL_LANGUAGE)) lang = "en";
  }
  return lang as EMAIL_LANGUAGE;
}
